import posthog from 'posthog-js'

export const acceptTracking = () => {
  posthog.opt_in_capturing();
  posthog.set_config({ persistence: 'localStorage+cookie' })
}

export const declineTracking = () => {
  posthog.opt_out_capturing();
  posthog.set_config({ persistence: 'memory' });
}
